<template>
    <v-content :style="{'background-image': `url('`+ require('../assets/bg-login.jpg') +`')`}"
               style="background-size: cover">
        <v-layout justify-center class="login-form" mb-12>
            <v-flex xs12 sm9 md4 mb-12>
                <v-card flat class="pa-7 login-card border-bottom-form mt-12 ">
                    <v-container v-if="request_resetPassword">
                        <v-layout justify-center>
                            <v-flex xs4>
                                <img alt="Vue logo" src="../assets/logo.png" style="width: 100%">
                            </v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex class="pt-12 pb-8">
                                <h3>หากคุณลืมหรัสผ่าน ไม่สามารถเข้าใช้งานระบบได้ </h3>
                                <h3>กรุณากรอก Email เพื่อรับ Link ในการเปลี่ยนรหัสผ่าน</h3>
                            </v-flex>
                        </v-layout>
                        <v-layout pt-10 justify-center>
                            <v-flex xs10>
                                <v-text-field
                                        dark
                                        v-model="email"
                                        background-color="#527281"
                                        placeholder="Email"
                                        height="10"
                                        solo
                                        min="0"
                                        required
                                ></v-text-field>
                            </v-flex>
                        </v-layout>

                        <v-layout justify-center>
                            <v-flex xs10>
                                <v-btn
                                        style="border-radius: 30px; background-color: #527281; color: #fff"
                                        class="ma-2 xs6 md6"
                                        @click="requestResetPassword"
                                >
                                    Send Password Reset Link
                                </v-btn>
                            </v-flex>
                        </v-layout>

                        <v-layout pb-12 justify-center>
                            <v-flex xs10>
                                <v-btn
                                        style="border-radius: 30px; background-color: gray; color: #fff"
                                        class="ma-2 xs6 md6"
                                        @click="$router.push('/').catch(err => {})"
                                >
                                    ย้อนกลับ
                                </v-btn>
                            </v-flex>
                        </v-layout>

                    </v-container>

                    <v-container v-else>
                        <v-layout justify-center>
                            <v-flex xs4>
                                <img alt="Vue logo" src="../assets/logo.png" style="width: 100%">
                            </v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex class="pt-12 pb-8">
                                <h3>{{message}}</h3>
                                <h3>ทางเราได้ส่งลิ้งค์เปลี่ยนรหัสผ่านไปที่อิเมล์ของท่าน กรุณาตรวจสอบ!</h3>
                            </v-flex>
                        </v-layout>

                        <v-layout pb-12 justify-center>
                            <v-flex xs10>
                                <v-btn
                                        style="border-radius: 30px; background-color: gray; color: #fff"
                                        class="ma-2 xs6 md6"
                                        @click="$router.push('/').catch(err => {})"
                                >
                                    ย้อนกลับ
                                </v-btn>
                            </v-flex>
                        </v-layout>

                    </v-container>

                </v-card>
            </v-flex>
        </v-layout>

        <loading
                color="#527281"
                :active.sync="isLoading"
                :can-cancel="false"
                :is-full-page="fullPage"
        ></loading>

        <Footer></Footer>
    </v-content>
</template>


<script>
    import Footer from '@/components/Footer.vue';
    import Swal from 'sweetalert2'
    import Loading from 'vue-loading-overlay';

    export default {
        name: "ForgotPassword.vue",
        components: {
            Footer,
            Loading
        },
        data() {
            return {
                request_resetPassword: true,
                message: '',
                isLoading: false,
                fullPage: true,
                email: null,
            }
        },
        methods: {
            requestResetPassword() {
                this.isLoading = true;
                this.request_resetPassword = true;
                this.$store.dispatch('Auth/requestResetPassword', {email: this.email}).then(res => {
                    this.isLoading = false;
                    this.request_resetPassword = false;
                    this.message = res.message;
                }, error => {
                    Swal.fire({
                        icon: 'error',
                        title: 'Email not found',
                        text: "ไม่พบที่อยู่ email ในระบบ กรุณาตรวจสอบใหม่อีกครั้ง"
                    })
                    this.isLoading = false;
                })
            },
        }

    }
</script>

<style lang="scss" scoped>
    .text-color {
        color: #84A2A8;
        font-size: 26px;
        font-weight: bold;
    }
    .login-form {
        .login-card {
            background: rgba(255,255,255,.18) !important;
        }
        .border-top-form {
            border-top-left-radius: 20px;
            border-top-right-radius: 20px;
        }
        .border-bottom-form {
            border-top-left-radius: 20px;
            border-top-right-radius: 20px;
            border-bottom-left-radius: 20px;
            border-bottom-right-radius: 20px;
        }
    }

</style>
